import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {ILesson} from "../../../constants/ILMS";

export const useGetThemeLessons = (projectId?: string, themeId?: string, t?: number) =>  {
    const [resp, setResp] = useState<ILesson[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!projectId || !themeId) return;

            setIsLoading(true)
            API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetThemeLessons')
                .get()
                .addQuery('projectId', projectId)
                .addQuery('themeId', themeId)
                .send()
                .then((r) => r.json())
                .then((r) => {
                    if (r?.status === 403) {
                        setIsLoading(false)
                        setError(true)
                        return;
                    }
                    setIsLoading(false)
                    setResp(r)
                })
                .catch((e) => {
                    setIsLoading(false)
                    setError(true)
                })
    }, [projectId, themeId, t])

    return {lessons: resp, isLoading, error};
}import {API,Endpoints} from '@brg/api';
import {useEffect, useState} from "react";
import {ILesson} from "../../../constants/ILMS";

export const useGetThemeLessons = (projectId?: string, themeId?: string, t?: number) =>  {
    const [resp, setResp] = useState<ILesson[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {

        if (!projectId || !themeId) return;

            setIsLoading(true)
            API.request()
                .endpoint(Endpoints.geoGateway)
                .url('/api/LMS/GetThemeLessons')
                .get()
                .addQuery('projectId', projectId)
                .addQuery('themeId', themeId)
                .send()
                .then((r) => r.json())
                .then((r) => {
                    if (r?.status === 403) {
                        setIsLoading(false)
                        setError(true)
                        return;
                    }
                    setIsLoading(false)
                    setResp(r)
                })
                .catch((e) => {
                    setIsLoading(false)
                    setError(true)
                })
    }, [projectId, themeId, t])

    return {lessons: resp, isLoading, error};
}